import React from 'react';
import { NewsfilateHeader } from '../components/NewsfilateHeader';
import { NewsfilateFooter } from '../components/NewsfilateFooter';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function NewsfilateTermsOfServicePage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1731">
      <NewsfilateHeader data-id="element-1732" />
      <main className="flex-grow pt-12 pb-24" data-id="element-1733">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-1734">
          <div className="mb-8" data-id="element-1735">
            <Link to="/products/newsfiliate" className="inline-flex items-center text-[#5e60ce] hover:text-[#4c4db6] font-medium" data-id="element-1736">
              <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-1737" />
              Back to Newsfiliate
            </Link>
          </div>
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 sm:p-10" data-id="element-1738">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-1739">
              Terms of Service
            </h1>
            <p className="text-gray-500 mb-8" data-id="element-1740">Last Updated: January 23, 2025</p>
            <div className="prose prose-lg max-w-none text-gray-700" data-id="element-1741">
              <p data-id="element-1742">
                Welcome to Newsfiliate (the "Service"). By accessing or using
                the Service, you agree to comply with and be bound by these
                Terms of Service ("Terms"). If you do not agree to these Terms,
                you may not access or use the Service.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1743">
                1. Acceptance of Terms
              </h2>
              <p data-id="element-1744">
                By creating an account, accessing, or using the Service, you
                confirm that you have read, understood, and agree to be bound by
                these Terms and our Privacy Policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1745">
                2. Eligibility
              </h2>
              <p data-id="element-1746">To use the Service, you must:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1747">
                <li data-id="element-1748">
                  Be at least 18 years old or have the consent of a parent or
                  guardian.
                </li>
                <li data-id="element-1749">
                  Provide accurate and truthful information when creating an
                  account.
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1750">
                3. Use of the Service
              </h2>
              <p data-id="element-1751">
                You agree to use the Service only for lawful purposes and in
                compliance with all applicable laws. You agree not to:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1752">
                <li data-id="element-1753">Interfere with or disrupt the Service.</li>
                <li data-id="element-1754">
                  Attempt to gain unauthorized access to the Service or its
                  data.
                </li>
                <li data-id="element-1755">
                  Use the Service to distribute malicious software or content.
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1756">
                4. User Data and Account Access
              </h2>
              <p data-id="element-1757">
                We store user data to provide and improve the Service. However,
                we do not sell your data to third parties. By using the Service,
                you grant us permission to:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1758">
                <li data-id="element-1759">
                  Store and process your data in accordance with our Privacy
                  Policy.
                </li>
                <li data-id="element-1760">Use your data internally to improve the Service.</li>
              </ul>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1761">
                Data Ownership:
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1762">
                <li data-id="element-1763">
                  You retain ownership of any data you submit to the Service.
                </li>
                <li data-id="element-1764">
                  You may request deletion of your data at any time by
                  contacting support@newsfiliate.co.
                </li>
              </ul>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1765">
                Access to Online Accounts:
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1766">
                <li data-id="element-1767">
                  To use certain features of the Service, you may be required to
                  provide access to an online account (e.g., third-party
                  services). By doing so, you authorize the Service to access
                  and retrieve information from the account solely for the
                  purpose of providing the Service.
                </li>
                <li data-id="element-1768">
                  You confirm that you have the right to grant this access and
                  that such access complies with the terms and conditions of the
                  third-party service.
                </li>
                <li data-id="element-1769">
                  We will not modify or perform transactions on your behalf
                  within these accounts unless explicitly authorized by you.
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1770">
                5. Privacy Policy
              </h2>
              <p data-id="element-1771">
                Your use of the Service is subject to our Privacy Policy, which
                explains how we collect, use, and protect your information. By
                using the Service, you consent to the collection and use of your
                data as described in the Privacy Policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1772">
                6. Intellectual Property
              </h2>
              <p data-id="element-1773">
                All content, design, and features of the Service are owned by
                Perpetual Press, Inc. dba POLN dba Newsfiliate or its licensors.
                You may not copy, modify, distribute, or reverse engineer any
                part of the Service without explicit permission.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1774">
                7. Account Security
              </h2>
              <p data-id="element-1775">
                You are responsible for maintaining the confidentiality of your
                account credentials. Notify us immediately if you suspect
                unauthorized use of your account. We are not liable for any loss
                or damage arising from unauthorized access to your account.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1776">
                8. Termination
              </h2>
              <p data-id="element-1777">
                We may suspend or terminate your access to the Service if you
                violate these Terms or engage in harmful behavior. You may also
                terminate your account at any time by contacting
                support@newsfiliate.co. Upon termination:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1778">
                <li data-id="element-1779">Your access to the Service will be revoked.</li>
                <li data-id="element-1780">
                  We will delete your stored data, except where required by law
                  to retain it.
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1781">
                9. Limitation of Liability
              </h2>
              <p data-id="element-1782">
                To the maximum extent permitted by law, Perpetual Press, Inc.
                dba POLN dba Newsfiliate is not liable for any indirect,
                incidental, or consequential damages arising from your use of
                the Service.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1783">
                10. Changes to the Terms
              </h2>
              <p data-id="element-1784">
                We reserve the right to update these Terms at any time. We will
                notify you of significant changes via email or through the
                Service. Your continued use of the Service after changes take
                effect constitutes your acceptance of the new Terms.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1785">
                11. Governing Law
              </h2>
              <p data-id="element-1786">
                These Terms are governed by the laws of the State of Delaware in
                the United States of America, without regard to conflict of laws
                principles.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1787">
                12. Contact Information
              </h2>
              <p data-id="element-1788">
                If you have any questions about these Terms, please contact us
                at:
              </p>
              <p className="mt-2" data-id="element-1789">
                <strong data-id="element-1790">Email:</strong> gavin.smith@creatorboost.ai
              </p>
              <p data-id="element-1791">
                <strong data-id="element-1792">Address:</strong> 3500 S Dupont Highway, Dover, Delaware
                19901
              </p>
              <p className="mt-8 text-center font-medium" data-id="element-1793">
                Thank you for using Newsfiliate.
              </p>
            </div>
          </div>
        </div>
      </main>
      <NewsfilateFooter data-id="element-1794" />
    </div>;
}